"use strict";

import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import D5SnackbarsStore from 'Stores/D5SnackbarsStore';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';
import amber from '@material-ui/core/colors/amber';
import green from '@material-ui/core/colors/green';
import Warning from '@material-ui/icons/Warning';
import Error from '@material-ui/icons/Error';
import Info from '@material-ui/icons/Info';
import Close from '@material-ui/icons/Close';
import CheckCircle from '@material-ui/icons/CheckCircle';
import classNames from 'classnames';
import { showSnackBar } from 'Actions/D5SnackbarsActions';
import { System } from "Constants/objects";

var D5SnackbarContentStyle = function D5SnackbarContentStyle(theme) {
  return {
    success: {
      backgroundColor: green[600]
    },
    error: {
      backgroundColor: theme.palette.error.dark
    },
    info: {
      backgroundColor: theme.palette.primary.dark
    },
    warning: {
      backgroundColor: amber[700]
    },
    icon: {
      fontSize: 20
    },
    iconVariant: {
      opacity: 0.9,
      marginRight: theme.spacing.unit
    },
    message: {
      display: 'flex',
      alignItems: 'center'
    }
  };
};

var variantIcon = {
  success: CheckCircle,
  warning: Warning,
  error: Error,
  info: Info
};

function D5SnackbarContent(props) {
  var classes = props.classes,
      className = props.className,
      message = props.message,
      onClose = props.onClose,
      variant = props.variant,
      other = _objectWithoutProperties(props, ["classes", "className", "message", "onClose", "variant"]);

  var Icon = variantIcon[variant];
  return React.createElement(SnackbarContent, _extends({
    className: classNames(classes[variant], className),
    "aria-describedby": "client-snackbar",
    message: React.createElement("span", {
      id: "client-snackbar",
      className: classes.message
    }, React.createElement(Icon, {
      className: classNames(classes.icon, classes.iconVariant)
    }), React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: message
      }
    })),
    action: [React.createElement(IconButton, {
      key: "close",
      "aria-label": "Close",
      color: "inherit",
      className: classes.close,
      onClick: onClose
    }, React.createElement(Close, {
      className: classes.icon
    }))]
  }, other));
}

D5SnackbarContent.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  message: PropTypes.node,
  onClose: PropTypes.func,
  variant: PropTypes.oneOf([System.SNACKBAR_TYPES.Success, System.SNACKBAR_TYPES.Warning, System.SNACKBAR_TYPES.Error, System.SNACKBAR_TYPES.Info]).isRequired
};
var D5SnackbarContentWrapper = withStyles(D5SnackbarContentStyle)(D5SnackbarContent);

var styles2 = function styles2(theme) {
  return {
    root: {
      zIndex: 1503
    }
  };
};

var D5Snackbars =
/*#__PURE__*/
function (_React$Component) {
  _inherits(D5Snackbars, _React$Component);

  function D5Snackbars(props) {
    var _this;

    _classCallCheck(this, D5Snackbars);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(D5Snackbars).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClose", function (event, reason) {
      if (reason === 'clickaway') {
        return;
      }

      showSnackBar({
        open: false
      });
    });

    _this.state = D5SnackbarsStore.getList();
    _this._onChange = _this._onChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(D5Snackbars, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      D5SnackbarsStore.addChangeListener(this._onChange);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      D5SnackbarsStore.removeChangeListener(this._onChange);
    }
  }, {
    key: "_onChange",
    value: function _onChange() {
      this.setState(D5SnackbarsStore.getList());
    }
  }, {
    key: "render",
    value: function render() {
      var classes = this.props.classes;
      return React.createElement("div", null, React.createElement(Snackbar, {
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'center'
        },
        classes: {
          root: classes.root
        },
        open: this.state.open,
        autoHideDuration: this.state.type === System.SNACKBAR_TYPES.Success ? 3000 : 5000,
        onClose: this.handleClose
      }, React.createElement(D5SnackbarContentWrapper, {
        onClose: this.handleClose,
        variant: this.state.type,
        message: this.state.message
      })));
    }
  }]);

  return D5Snackbars;
}(React.Component);

D5Snackbars.propTypes = {
  classes: PropTypes.object.isRequired
};
export default withStyles(styles2)(D5Snackbars);